module.exports = __webpack_public_path__ + "img/horizontal_6_7_0.a8f1bf00.png";